<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">FechaApli</th>
          <th scope="col">Observacion</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">VacunaProdNombre</th>
          <th scope="col">VacunaNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vacunapers in datosPaginados" :key="vacunapers.idVacunaPers">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(vacunapers.idVacunaPers)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(vacunapers.idVacunaPers)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(vacunapers.fechaApli, 'DD/MM/YYYY')}}</td>
          <td>{{vacunapers.observacion}}</td>
          <td>{{getFormattedDate(vacunapers.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(vacunapers.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(vacunapers.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{vacunapers.vacunaProdNombre}}</td>
          <td>{{vacunapers.vacunaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteVacunaPers(vacunapers.idVacunaPers)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaPers" class="form-label">IdVacunaPers</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaPers" name="idVacunaPers" v-model="datoVacunaPers.idVacunaPers" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Persona -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoVacunaPers.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Persona -->
<!-- Botón Lista de Valores  Vacuna -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idVacuna" class="form-label"> Vacuna</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idVacuna" name="idVacuna" v-model="datoVacunaPers.idVacuna">
                      <option v-for="vacuna in vacunas" :value="vacuna.idVacuna" :key="vacuna.idVacuna">
                        {{ vacuna.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Vacuna -->
<!-- Botón Lista de Valores  Vacuna Prod -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idVacunaProd" class="form-label"> Vacuna Prod</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idVacunaProd" name="idVacunaProd" v-model="datoVacunaPers.idVacunaProd">
                      <option v-for="vacunaProd in vacunaProds" :value="vacunaProd.idVacunaProd" :key="vacunaProd.idVacunaProd">
                        {{ vacunaProd.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Vacuna Prod -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoVacunaPers.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoVacunaPers.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaApli" class="form-label">FechaApli</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaApli" name="fechaApli" v-model="datoVacunaPers.fechaApli" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoVacunaPers.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoVacunaPers.fechaReg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoVacunaPers.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarVacunaPers" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditVacunaPers" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
//import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      vacunaperss : [],
      datoVacunaPers : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      personas: [],
      vacunas: [],
      vacunaProds: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
/*
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },
*/

  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.navbarRef.toggleProcesos()
    this.$refs.navbarRef.toggleReportes()
    this.$refs.navbarRef.toggleParametros()
    this.$refs.navbarRef.toggleAyuda()
    this.fetchPersonas()
    this.fetchVacunas()
    this.fetchVacunaProds()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.vacunaperss.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwvacunaperss/nombre/'+this.nombreBusqueda).then(response=>{
          this.vacunaperss=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.vacunaperss.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwvacunaperss').then(response=>{
      this.vacunaperss=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.vacunaperss.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idPersona'
        ,'idVacuna'
        ,'idVacunaProd'
        ,'fechaApli'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idPersona'
        ,'idVacuna'
        ,'idVacunaProd'
        ,'fechaApli'
        ,'observacion'
      ];
      return validarForm(this.datoVacunaPers, requiredFields, requiredFieldsText);
    },
    async guardarVacunaPers(){
      if(this.validarForm() === 1){
        try {
          this.datoVacunaPers.idUsuarioReg = window.sessionStorage.getItem("idUsuarioReg");
          await api.post('/vacunaperss', this.datoVacunaPers)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "VacunaPers creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditVacunaPers(){
      if(this.validarForm() === 1){
        try {
          this.datoVacunaPers.idUsuarioAct = window.sessionStorage.getItem("idUsuarioAct");
          await api.post('/vacunaperss', this.datoVacunaPers)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "VacunaPers creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoVacunaPers={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idVacunaPers){
      this.modalWindow = true
      if(idVacunaPers != null){    
           api.get('/vwvacunaperss/'+idVacunaPers).then(resp=>{
          this.datoVacunaPers = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idVacunaPers){
      if(idVacunaPers != null){
        this.$router.push('/vacunapersmd/'+idVacunaPers)
      }
    },
    async deleteVacunaPers (idVacunaPers) {
      try{
        await api.delete('/vacunaperss/'+idVacunaPers)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchVacunas() {
      fetch('http://localhost:8080/api/v1/vacunas')
        .then(response => response.json())
        .then(data => {
          this.vacunas = data;
        })
        .catch(error => {
          console.error('Error fetching vacunas:', error);
        });
    },
    fetchVacunaProds() {
      fetch('http://localhost:8080/api/v1/vacunaprods')
        .then(response => response.json())
        .then(data => {
          this.vacunaProds = data;
        })
        .catch(error => {
          console.error('Error fetching vacunaProds:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
